<template>
	<div>
		<v-dialog v-model="fieldListDialog" no-click-animation persistent scrollable content-class="full-height select_field_dialog" lazy transition="dialog-bottom-transition">
	        <v-card>
	        	<v-card-title noshadow class="dialog_searchbox">
	        		<v-subheader full-width>Select Field</v-subheader>
	        		<!-- <v-spacer></v-spacer>
	        		<v-btn color="primary" small flat justify-content-to-end nomargin :ripple="false" @click="fn_newField">new</v-btn></v-subheader> -->

	        		<v-text-field  solo flat placeholder="Search" v-model="searchValue"></v-text-field>
	        	</v-card-title>

		        <v-card-text full-height nopadding :class="{'no-items-list-card': !filteredItems.length}">

			        <v-list nopadding>
			        	<v-list-tile v-for="(item, index) in filteredItems" :key="index" @click="addField(item)">

				            <v-list-tile-content>
				              <v-list-tile-title>{{item.name}}</v-list-tile-title>
				            </v-list-tile-content>

			        	</v-list-tile>
			        </v-list>

			        <div class="display_msg" v-if="!filteredItems.length">No Items</div>
		        </v-card-text>
		        <v-divider></v-divider>
		        <v-card-actions>
		        	<v-spacer></v-spacer>
          			<v-btn small color="blue darken-1" flat @click="$parent.fn_closeDialog">close</v-btn>
		        </v-card-actions>
		    </v-card>


	    </v-dialog>
	</div>
</template>

<script>
	export default{
		props:['addField'],
		data(){
			return{
				fieldsItems:[],
				selectedField: null,
				fieldListDialog:false,
				searchValue:''
			}
		},
		methods:{
			openDialogWeb: function () {
				this.fn_getItems();
				this.searchValue = '';
				this.fieldListDialog = true;
			},
			closeDialogWeb: function () {
				this.fieldListDialog = false;
			},
			fn_newField: function () {
				this.$router.push({path:'/fields/new', query:{tagId:this.guidWeb(), ls:1}});
			},
			fn_getItems: function () {
		        let filterObject = {};
		        // filterObject.groupTypeId = 101;
		        filterObject.groupTypeId = null;

		        let self = this;
		        this.getItems("FieldList", filterObject, 
		          {
		            onSuccess: function (response) {
		              console.log(response);
		              self.fieldsItems = JSON.parse(response);
		            },
		            onError: function (error) {
		              console.log(error);
		            }
		          }
		        )
		    },
		},
		computed:{
			filteredItems: function () {
		        let searchText = this.searchValue.toLowerCase();

		        return this.fieldsItems.filter(item => {
		          let fieldName = item.name.toLowerCase();
		          return fieldName.match(searchText);
		        })
		      }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/print_templates/dialogs/dialog_fields.vue